import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate"
import moment from 'moment'
import SecureLS from "secure-ls"

import router from '@/router'
import shop from '@/api/shop'


const ls = new SecureLS({ isCompression: false });

const store = createStore({
    state: {
        products: [],
        customer: {},
        response_data: [],
        school: [],
        proofcard: [],
        cart_products: [],
        school_delivery: false,
        cart_totals: {
            sub_total: 0.00,
            shipping_total: 4.00,
            late_fee: 5.00,
            cart_total: 0.00,
        },
        checkout_status: null,
    },

    getters: {
        availableProducts (state, getters) {
            return state.products.filter(product => product.published == true)
        },

        schoolDelivery (state, getters) {
            return state.school_delivery
        },

        cartProducts (state, getters) {
            return state.cart_products
        },

        cartSubTotal (state, getters) {
            return getters.cartProducts.reduce((subTotal, product) => subTotal + product.price * product.quantity, 0)
        },

        cartShippingTotal (state, getters) {
            if (state.school_delivery ==  true) {
                return 0
            } else {
                return 4
            }
        },

        cartLateFee (state, getters) {
            // find out if todays date is after school cut off date
            if ( moment(state.school.order_cutoff_date).isBefore() ) return state.cart_totals.late_fee
            return 0
        },

        cartTotal (state, getters) {
            return +getters.cartProducts.reduce((total, product) => total + product.price * product.quantity, 0) + +getters.cartShippingTotal + +getters.cartLateFee
        },
        customer (state, getters) {
            return state.customer
        },
        responseData (state, getters) {
            return state.response_data
        },
        school (state, getters) {
            return state.school
        },
        proofcard (state, getters) {
            return state.proofcard
        },
    },

    actions: { // to dispatch
        startAgain (context) {
            context.commit('startAgain')
            router.push({name: 'Start'})
        },

        dispatchNotification (context, message, status = 'success', pos = 'bottom-right') {
            UIkit.notification({
                message: message,
                status: status,
                pos: pos,
                timeout: 2000,
            })
        },

        fetchProducts (context) {
            return new Promise((resolve, reject) => {
                shop.getProducts(products => {
                    context.commit('setProducts', products)
                    resolve()
                })
            });
            // make the api call
            // run setProducts mutation
        },

        updateDelivery (context, value) {
            context.commit('updateDelivery', value)
        },

        addProductToCart (context, product) {
            if (product => product.published == true) {
                // find cartItem
                const cartItem = context.state.cart_products.find(item => item.product_code === product.product_code)
                if (!cartItem) {
                    context.commit('pushProductToCart', product)
                    store.dispatch('dispatchNotification', `${product.package} added to cart`)
                } else {
                    context.commit('increaseItemQuantity', cartItem)
                    store.dispatch('dispatchNotification', `${product.package} updated in cart`)
                }
            }
        },

        removeProductFromCart (context, product) {
            // find cartItem
            const cartItem = context.state.cart_products.find(item => item.product_code === product.product_code)
            if (cartItem.quantity <= 1) {
                context.commit('removeProductFromCart', cartItem)
                store.dispatch('dispatchNotification', `${product.package} removed from cart`)
            } else {
                context.commit('decreaseItemQuantity', cartItem)
                store.dispatch('dispatchNotification', `${product.package} decreased in cart`)
            }
        },

        checkout ({state, commit}) {
            shop.buyProducts(
                state.cart_products,
                () => {
                    commit('emptyCart')
                    commit('setCheckoutStatus', 'success')
                },
                () => {
                    commit('setCheckoutStatus', 'failed')
                }
            )
        },

        updateCustomer ({ commit }, event) {
            commit('updateCustomer', event.target.value)
        },

        updateResponseData ({ commit }, data) {
            commit('updateResponseData', data)
        },
    },

    mutations: {
        startAgain (state) {
            state.customer = {}
            state.response_data = []
            state.school = []
            state.proofcard = []
            state.cart_products = []
            state.school_delivery = false
        },

        updateDelivery (state, value) {
            state.school_delivery = value
        },

        updateCustomer (state) {
            state.customer.[event.target.name] = event.target.value
        },

        updateResponseData (state, data) {
            state.response_data = data

            if (data.set_school) {
                state.customer.school = data.set_school.name
                state.school = data.set_school
            }

            if (data.set_image) {
                state.proofcard = data.set_image
            }
        },

        setProducts (state, products) {
            // update products
            state.products = products
        },

        pushProductToCart (state, product) {
            state.cart_products.push({
                product_id: product.product_id,
                product_code: product.product_code,
                image: product.image,
                thumbnail: product.thumbnail,
                package: product.package,
                filters: product.filters,
                price: product.price,
                quantity: 1,
            })
        },

        increaseItemQuantity (state, cartItem) {
            cartItem.quantity++
        },

        decreaseItemQuantity (state, cartItem) {
            cartItem.quantity--
        },

        removeProductFromCart (state, cartItem) {
            state.cart_products.pop(cartItem, 1)
        },

        setCheckoutStatus (state, status) {
            state.checkout_status = status
        },

        emptyCart (state, status) {
            state.cart_products = []
        },


    },

    plugins: [
        createPersistedState({
            storage: {
                getItem: key => ls.get(key),
                setItem: (key, value) => ls.set(key, value),
                removeItem: key => ls.remove(key)
            }
        }),
    ],
});

export default store;

// TODO: add numbers in array: https://www.w3schools.com/jsref/tryit.asp?filename=tryjsref_reduce
